import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';

import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  DialogProps,
  IconButton,
  Stack,
  TextField,
} from '@mui/material';
import CombinationChart from './CombinationChart';
import './style.css';
import { Link, useNavigate } from 'react-router-dom';
import {
  getCourseAdministrationCountBasedOnStatus,
  getFacultyCourseCardCountList,
  getFacultyDashboardList,
} from '../../../reduxStore/reducer/dashboardReducer';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../reduxStore/Store';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { green } from '@mui/material/colors';
import moment from 'moment';
import { Scrollbar } from 'react-scrollbars-custom';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SendIcon from '@mui/icons-material/Send';
import {
  getCourseDetail,
  sendReminder,
} from '../../../reduxStore/reducer/courseReducer';
import AddCourseAssessment from '../../course/AddCourseAssessment';

const FacultyDashboard = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [showAllCards, setShowAllCards] = React.useState(false);

  const [cardsData, setCardsData] = React.useState([]);

  const [facultyCount, setFacultyCount] = React.useState<any[]>([]);

  const setIsLoadingState = (loading: boolean) => {
    setIsLoading(loading);
  };

  const formatNumberForDisplay = (value: Number) => {
    return  Number.isNaN(value) ? "" : value.toLocaleString("en-US");
  };

  const getYearsList = () => {
    const currentYear = new Date().getFullYear();
    const years = ['Overall'];
    for (let year = currentYear; year >= currentYear - 20; year--) {
      years.push(year.toString());
    }
    return years;
  };

  const years = getYearsList();
  const [selectedYear, setSelectedYear] = React.useState('Overall');
  const [showAllYears, setShowAllYears] = React.useState(false);

  const handleYearChange = (event: any) => {
    setSelectedYear(event.target.value);
  };

  const toggleShowAllYears = () => {
    setShowAllYears((prev) => !prev);
  };

  const displayedYears = showAllYears ? years : years.slice(0, 6); // Show first 5 years + "Overall"

  interface CourseCardData {
    term_name: string;
    name: string;
    course_name: { name: string; id: string; last_reminder_sent: any }[]; // Added this line
  }
  const [courseCardsData, setCourseCardsData] = React.useState<
    CourseCardData[]
  >([]);
  // console.log(courseCardsData, 'courseCardsData');

  const [selectedTerm, setSelectedTerm] = React.useState('');
  const [selectedItems, setSelectedItems] = React.useState<
    { name: string; id: string; last_reminder_sent: any }[]
  >([]);

  const handleTermSelect = (term: string) => {
    setSelectedTerm(term);
    const selectedCourse = courseCardsData.find(
      (course) => course.term_name === term
    );
    if (selectedCourse) {
      // Use selectedCourse.course_name directly to populate items
      setSelectedItems(selectedCourse.course_name || []);
    } else {
      setSelectedItems([]);
    }
  };

  const uniqueTerms = [
    ...new Set(courseCardsData.map((course) => course.term_name)),
  ];

  React.useEffect(() => {
    if (uniqueTerms.length > 0 && !selectedTerm) {
      const defaultTerm = uniqueTerms[0];
      setSelectedTerm(defaultTerm);
      const selectedCourse = courseCardsData.find(
        (course) => course.term_name === defaultTerm
      );
      if (selectedCourse) {
        // Use selectedCourse.course_name directly to populate items
        setSelectedItems(selectedCourse.course_name || []);
      } else {
        setSelectedItems([]);
      }
    }
  }, [uniqueTerms, selectedTerm]);

  // Items for rendering in UI
  const items = selectedItems;

  const visibleCards = showAllCards ? cardsData : cardsData.slice(0, 4);
  const handleMoreClick = () => {
    setShowAllCards((prevShowAllCards) => !prevShowAllCards);
  };

  const navigate = useNavigate();
  React.useEffect(() => {
    // Check for stored year in localStorage and use it as default
    const storedYear = localStorage.getItem('selectedYear') || 'Overall';
    setSelectedYear(storedYear);

    // ... (existing code)
  }, [dispatch]);

  React.useEffect(() => {
    dispatch(getCourseAdministrationCountBasedOnStatus(setCardsData));
    dispatch(getFacultyDashboardList(setFacultyCount, setIsLoadingState, selectedYear));
    dispatch(getFacultyCourseCardCountList(setCourseCardsData));
  }, [selectedYear, dispatch]);
  const [age, setAge] = React.useState('');
  const handleChange = (event: SelectChangeEvent) => {
    setAge(event.target.value as string);
  };
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

  const StyledPaper = styled(Paper)(({ theme }) => ({
    width: '100%',
    maxWidth: 560,
    bgcolor: 'background.paper',
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: theme.shadows[3], // Adjust the shadow intensity by changing the value (0 to 24)
  }));
  const [assessmentInitialValues, setAssessmentInitialValues] =
    React.useState<any>();
  const [openAssessment, setOpenAssessment] = React.useState<boolean>(false);
  const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');
  const [initialValues, setInitialValue] = React.useState<any>({
    id: '',
    assessment_id: {
      official_name: '',
      assessment_id: '',
      code: '',
    },
    no_of_administrations: 2,
    created_by: '',
  });

  const handleAddAssessment = (id: string) => {
    getCourseDetail({ id }).then((data: any) => {
      setAssessmentInitialValues(data);
      setOpenAssessment(true);
      setScroll('paper');
    });
  };
  const [isLoading, setIsLoading] = React.useState(false);
  const [loadingStates, setLoadingStates] = React.useState<{
    [key: string]: boolean;
  }>({});
  const handleSendReminder = (courseId: string) => {
    // Check if the specific course is already loading
    if (loadingStates[courseId]) return;

    // Set loading state for this specific course
    setLoadingStates((prev) => ({ ...prev, [courseId]: true }));

    sendReminder({ courseId })
      .then((response: any) => {
        if (response?.success && response?.last_reminder) {
          setSelectedItems((prevItems) =>
            prevItems.map((item) =>
              item.id === courseId
                ? { ...item, last_reminder_sent: response.last_reminder }
                : item
            )
          );
          dispatch(getFacultyCourseCardCountList(setCourseCardsData));
        } else {
          console.error('Reminder not sent or no data');
        }
      })
      .finally(() => {
        // Clear loading state for this specific course
        setLoadingStates((prev) => ({ ...prev, [courseId]: false }));
      });
  };

  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Stack
          direction='row'
          justifyContent='flex-end'
          alignItems='center'
          spacing={3}
          p={1}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div>
              <label htmlFor='yearSelect'>Year:</label>
            </div>
            <div>
              <TextField
                sx={{ width: '200px' }}
                id='yearSelect'
                select
                value={selectedYear}
                onChange={handleYearChange}
                SelectProps={{
                  MenuProps: {
                    PaperProps: {
                      style: { maxHeight: 300, overflow: 'auto' },
                    },
                  },
                }}
              >
                {displayedYears.map((year) => (
                  <MenuItem key={year} value={year}>
                    {year}
                  </MenuItem>
                ))}
                {!showAllYears && (
                  <MenuItem disableRipple>
                    <Stack spacing={2} sx={{ width: '100%' }}>
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleShowAllYears();
                        }}
                        sx={{ width: '100%' }}
                      >
                        Expand More
                      </Button>
                    </Stack>
                  </MenuItem>
                )}
                {showAllYears && (
                  <MenuItem disableRipple>
                    <Stack spacing={2} sx={{ width: '100%' }}>
                      <Button
                        variant='outlined'
                        size='small'
                        onClick={(e) => {
                          e.stopPropagation();
                          toggleShowAllYears();
                        }}
                        sx={{ width: '100%' }}
                      >
                        Show Less
                      </Button>
                    </Stack>
                  </MenuItem>
                )}
              </TextField>
            </div>
          </div>
        </Stack>
        <Grid container rowSpacing={5} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} sm={6} md={6} lg={12} xl={12}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <link
                  rel='stylesheet'
                  href='https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css'
                />
                <div
                  style={{ minHeight: '100px', minWidth: '100px' }}
                  className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#f9b115] to-orange-300 text-white animate__animated animate__bounce shadow-xl'
                >
                  <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                    Students
                  </h2>
                  <p className='text-black text-2xl font-bold flex items-center justify-center'>
                    { isLoading? <div className='loading-spinner'></div>: facultyCount.length > 0
                      ? formatNumberForDisplay(Number(facultyCount[0].overall_course_students_count))
                      : ''}
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <Link to='/course'>
                  <div
                    style={{ minHeight: '100px', minWidth: '100px' }}
                    className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#4caf50] to-green-300 text-white animate__animated animate__bounce shadow-xl'
                  >
                    <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                      Courses
                    </h2>
                    <p className='text-black text-2xl font-bold flex items-center justify-center'>
                      {isLoading? <div className='loading-spinner'></div>:facultyCount.length > 0
                        ? formatNumberForDisplay(Number(facultyCount[0].overall_course_count))
                        : ''}
                    </p>
                  </div>
                </Link>
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <div
                  style={{ minHeight: '100px', minWidth: '100px' }}
                  className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-[#e55353] to-red-300 text-white animate__animated animate__bounce shadow-xl'
                >
                  <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                    Assessments
                  </h2>
                  <p className='text-black text-2xl font-bold flex items-center justify-center'>
                    {isLoading? <div className='loading-spinner'></div>:facultyCount.length > 0
                      ? formatNumberForDisplay(Number(facultyCount[0].overall_assessment_count))
                      : ''}
                  </p>
                </div>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={6} lg={2.4} xl={2.4}>
                <Link to="/addcourse">
                  <div
                    style={{ minHeight: '100px', minWidth: '100px' }}
                    className="mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-orange-500 to-orange-300 text-white animate__animated animate__bounce shadow-xl"
                  >
                    <h2 className="text-gray-100 title-font text-base font-bold p-4">
                      Add Course
                    </h2>
                    <p className="text-black text-2xl font-bold flex items-center justify-center">
                      +
                    </p>
                  </div>
                </Link>
              </Grid> */}
              <Grid item xs={12} sm={6} md={6} lg={3} xl={3}>
                <div
                  style={{ minHeight: '100px', minWidth: '100px' }}
                  className='mt-4 block relative h-32 rounded overflow-hidden bg-gradient-to-r from-blue-900 to-blue-200 text-white animate__animated animate__bounce shadow-xl'
                >
                  <h2 className='text-gray-100 title-font text-base font-bold p-4'>
                    Administrations
                  </h2>
                  <p className='text-black text-2xl font-bold flex items-center justify-center'>
                    {isLoading? <div className='loading-spinner'></div>:facultyCount.length > 0
                      ? formatNumberForDisplay(Number(facultyCount[0].overall_course_administration_count))
                      : ''}
                  </p>
                </div>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={4} md={4} lg={6} xl={6}>
            <StyledPaper
              elevation={0}
              sx={{
                width: '100%',
                maxWidth: '100%',
                bgcolor: 'background.paper',
              }}
            >
              <Typography
                variant='h6'
                component='div'
                sx={{ px: 2, py: 1, textAlign: 'center' }}
              >
                Upcoming Assessment Administration Dates
              </Typography>
              <div>
                <Scrollbar style={{ width: '100%', height: 400 }}>
                  {visibleCards?.map((d: any) => (
                    <List key={d.id}>
                      <ListItem
                        alignItems='flex-start'
                        sx={{ cursor: 'pointer' }}
                      >
                        <ListItemAvatar>
                          <Avatar
                            sx={{ bgcolor: green[500] }}
                            variant='rounded'
                          >
                            <AssignmentIcon />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          // primary={d.official_name}
                          children={
                            <>
                              {d.official_name}{' '}
                              {/* <Chip label={d.adm_id} size="small" /> */}
                              <div style={{ display: 'flex', gap: '20px' }}>
                                <div>
                                  <Chip label={d.course_name} size='small' />
                                </div>
                                <div style={{ display: 'flex', gap: '10px' }}>
                                  <div>
                                    {d.ass_code} {'-'}
                                  </div>
                                  <div>{d.administration_no}</div>
                                </div>
                              </div>
                            </>
                          }
                          onClick={() =>
                            navigate(
                              `/administration/${d.adm_id}/${d.cass_id}/${d.c_id}`
                            )
                          }
                          secondary={
                            <div
                              style={{
                                display: 'flex',
                                marginTop: '5px',
                                gap: '5px',
                              }}
                            >
                              <Typography variant='body2' color='text.primary'>
                                Start Date:
                              </Typography>
                              <Typography
                                variant='body2'
                                color='text.primary'
                                style={{ marginRight: '20px' }}
                              >
                                {moment(d.start_date_time).format(
                                  'MM-DD-YYYY hh:mm A'
                                )}
                              </Typography>
                              <Typography variant='body2' color='text.primary'>
                                End Date:
                              </Typography>
                              {moment(d.end_date_time).format(
                                'MM-DD-YYYY hh:mm A'
                              )}
                            </div>
                          }
                        />
                      </ListItem>
                      <Divider variant='inset' component='li' />
                    </List>
                  ))}
                  {!showAllCards && cardsData.length > 4 && (
                    <Stack spacing={2} sx={{ p: 2 }}>
                      <Button
                        variant='outlined'
                        onClick={handleMoreClick}
                        sx={{ width: '100%' }}
                      >
                        More
                      </Button>
                    </Stack>
                  )}
                </Scrollbar>
              </div>
            </StyledPaper>
          </Grid>
          <Grid item xs={12} sm={4} md={4} lg={6} xl={6}>
            <div>
              <Select
                style={{ width: '100%' }}
                value={selectedTerm}
                onChange={(e) => handleTermSelect(e.target.value)}
              >
                {uniqueTerms.map((term, index) => (
                  <MenuItem key={index} value={term}>
                    {term}
                  </MenuItem>
                ))}
              </Select>
            </div>
            <Card sx={{ maxWidth: '100%' }}>
              <div className='mt-2 block relative  rounded overflow-hidden bg-gradient-to-r from-[#39f] to-blue-300 text-white shadow-md shadow-lg'>
                <CardHeader
                  avatar={
                    <Avatar
                      sx={{ backgroundColor: 'black' }}
                      aria-label='recipe'
                    >
                      <AutoStoriesIcon />
                    </Avatar>
                  }
                  titleTypographyProps={{
                    variant: 'h6',
                    sx: { fontSize: '25px', color: 'white' },
                  }}
                  title={
                    // <div style={{ display: 'flex', alignItems: 'center' }}>
                    //   Courses

                    //   <div>123</div>
                    // </div>
                    <div
                      style={{
                        display: 'flex',
                        gap: '40px',
                        // flexDirection: 'row',
                        // justifyContent: 'space-evenly',
                      }}
                    >
                      <div>Courses</div>
                      <div>
                        {' '}
                        <Link to='/addcourse'>
                          <Button
                            variant='contained'
                            style={{ textTransform: 'capitalize' }}
                          >
                            Add Course
                          </Button>
                        </Link>
                      </div>
                    </div>
                  }
                />
              </div>

              <div>
                <Scrollbar style={{ width: '100%', height: 250 }}>
                  <Typography variant='body2' color='text.secondary'>
                    {items.map((item: any, index) => (
                      <Stack
                        key={item.id}
                        direction='row'
                        alignItems='center'
                        justifyContent='space-between'
                        spacing={2}
                        sx={{
                          height: '4rem',
                          px: 2,
                          ...(index % 2 === 0
                            ? { color: 'blue.500' }
                            : {
                                background:
                                  'linear-gradient(to right, #39f, #7ecdf9)',
                                color: 'white',
                              }),
                        }}
                      >
                        {/* Index and Name Section */}
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              backgroundColor:
                                index % 2 === 0 ? '#1976d2' : 'white',
                              color: index % 2 === 0 ? 'white' : '#1976d2',
                              border: '1px solid #1976d2',
                              borderRadius: '50%',
                              width: '1.5rem',
                              height: '1.5rem',
                              marginRight: '8px',
                            }}
                          >
                            {index + 1}
                          </div>
                          <Typography
                            variant='body2'
                            sx={{
                              fontWeight: 'bold',
                              fontSize: '14px',
                              color: index % 2 === 0 ? '#1976d2' : 'white',
                              overflow: 'hidden', // Ensures overflowing content is hidden
                              whiteSpace: 'nowrap', // Prevents the text from wrapping
                              textOverflow: 'ellipsis', // Adds "..." for overflowing text
                              maxWidth: '120px', // Set a maximum width to control the ellipsis effect
                            }}
                          >
                            {item.name}
                          </Typography>
                        </div>

                        {/* Actions Section */}
                        <div>
                          <Button
                            size='small'
                            variant='contained'
                            sx={{
                              textTransform: 'none',
                              backgroundColor:
                                index % 2 === 0 ? 'primary.main' : 'white',
                              color: index % 2 === 0 ? 'white' : 'black',
                              '&:hover': {
                                backgroundColor:
                                  index % 2 === 0 ? 'primary.dark' : '#f0f0f0',
                              },
                            }}
                            onClick={() => handleAddAssessment(item.id)}
                          >
                            Add Assessment
                          </Button>
                          <Button
                            variant='outlined'
                            size='small'
                            sx={{
                              textTransform: 'none',
                              backgroundColor: '#e3f0ff',
                              marginLeft: '20px',
                            }}
                            onClick={() => handleSendReminder(item.id)}
                            disabled={loadingStates[item.id] || false}
                          >
                            <SendIcon sx={{ fontSize: '1.1rem' }} />
                            Send Reminder
                          </Button>
                          <p
                            style={{
                              color: index % 2 === 0 ? '#4caf50' : 'white',
                            }}
                          >
                            Last Reminder:{' '}
                            {item.last_reminder_sent
                              ? moment(moment(item.last_reminder_sent).utc())
                                  .local()
                                  .format('MM-DD-YYYY hh:mm a')
                              : 'No Reminder Sent'}
                          </p>
                        </div>
                      </Stack>
                    ))}
                  </Typography>
                </Scrollbar>
              </div>

              <div className='h-16 bg-gradient-to-r from-[#39f] to-blue-300 text-white shadow-md shadow-lg flex items-center justify-center'>
                <Link to='/course'>Load More...</Link>
              </div>
            </Card>
          </Grid>
        </Grid>
      </Box>
      {assessmentInitialValues && (
        <AddCourseAssessment
          // isEdit={isEdit}
          // setIsEdit={setIsEdit}
          openAssessment={openAssessment}
          setOpenAssessment={setOpenAssessment}
          assessmentInitialValues={assessmentInitialValues}
          // params={masterGridparams}
          // getAssessmentByCourse={getAssessmentByCourse}
          scroll={scroll}
          initialValues={initialValues}
          setInitialValue={setInitialValue}
        />
      )}
    </div>
  );
};
export default FacultyDashboard;
